import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import _typeof from "@babel/runtime-corejs3/helpers/typeof";
import { get, set } from 'lodash';
export function noop() {}
export function isObject(obj) {
  return _typeof(obj) === 'object' && obj !== null && !_Array$isArray(obj);
}
export function isPromise(obj) {
  return isObject(obj) && typeof obj.then === 'function';
}
export function isFunction(obj) {
  return obj && typeof obj === 'function';
}
export function isNullOrUndefined(obj) {
  return obj === null || obj === undefined;
} // from https://github.com/hughsk/flat/blob/master/index.js

export function flatten() {
  var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var output = {};

  function step(obj, prev) {
    var _context;

    _forEachInstanceProperty(_context = _Object$keys(obj)).call(_context, function (key) {
      var _context2;

      var value = obj[key];
      var newKey = prev ? _concatInstanceProperty(_context2 = "".concat(prev, ".")).call(_context2, key) : key;

      if ((isObject(value) || _Array$isArray(value)) && _Object$keys(value).length) {
        return step(value, newKey);
      }

      output[newKey] = value;
    });
  }

  step(target);
  return output;
}
export function flattenArray(arr) {
  return _concatInstanceProperty([]).apply([], arr);
}
export function concatenateErrors(errors) {
  return _reduceInstanceProperty(errors).call(errors, function (acc, err) {
    var _context3;

    var flatError = flatten(err);

    _forEachInstanceProperty(_context3 = _Object$keys(flatError)).call(_context3, function (key) {
      if (!get(acc, key)) {
        // All falsey values are considered to be non-errors
        set(acc, key, flatError[key] || null);
      }
    });

    return acc;
  }, {});
}
export function reduceError(errors, name) {
  return _reduceInstanceProperty(errors).call(errors, function (acc, err) {
    if (!acc) {
      acc = isObject(err) ? get(err, name, null) : err;
    }

    return acc;
  }, null) || null // All falsey values are considered to be non-errors
  ;
}
var counter = 0;
export function uuid(a) {
  return process.env.NODE_ENV === 'test' ? "uuid-".concat(++counter) : a ? (a ^ Math.random() * 16 >> a / 4).toString(16) : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, uuid);
}